<template>
  <v-expansion-panel @change="validate()">
    <v-expansion-panel-header>BC</v-expansion-panel-header>
    <v-expansion-panel-content @>
      <v-form ref="form">
        <v-text-field label="Store number" v-model="bc.storeNumber" outlined dense/>
      </v-form>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'ConfigurationSettingsBC',
  data() {
    return {
      bc: {},
    }
  },
  async created() {
    const results = await this.$apiCall(`query ConfigurationSettingsBC {
                                            bcPreferences {
                                              storeNumber,bcPeriodEnd
                                            }
                                          }`,
                                        {});
    if (!results.error) {
      this.bc = results.data.bcPreferences;
    }
  },
  watch: {
    bc: {
      async handler() {
        await this.$apiCall(`mutation ConfigurationSettingsBC($input:BCPreferencesInput!) {
                              bcSetPreferences(input:$input) {
                                storeNumber
                              }
                            }`,
                            {input:this.bc});
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    validate() {
      this.$nextTick(() => this.$refs.form.validate());
    }
  }
}
</script>